import { useMutation } from '@tanstack/react-query';
import { user } from '@api/apis';
import { ResponseErrorNoticeType } from '@utils/errors';
import { Logger } from '@utils/logger';

/* Hooks */
import useNotice from '@hooks/useNotice';

export default function useUserMutationResetPassword() {
  const { success, error } = useNotice();

  return useMutation({
    mutationFn: async (email: string) => {
      const response = await user.resetPassword({ email });

      if (response.err) throw new Error(response);

      return response.data;
    },
    onSuccess: data => {
      success('Reset Password Link sent!');
    },

    onError: (err: ResponseErrorNoticeType | Error) => {
      error('Something went wrong');
      Logger('useUserMutationResetPassword')(err as Error);
    },
  });
}
